import {
  type DietaryPreferencesTypes,
  type AllergenOrDietaryRestriction,
} from '@sg/shared-fe-features-menu';

/**
 * Converts the dietary preferences object to a list of filtered restrictions.
 */
export function getDietaryPreferencesList(
  dietaryPreferences: DietaryPreferencesTypes,
): AllergenOrDietaryRestriction[] {
  const preferencesKeys = Object.keys(dietaryPreferences) as AllergenOrDietaryRestriction[]; // prettier-ignore

  return preferencesKeys.filter((restriction) => Boolean(dietaryPreferences[restriction]));
}
